import axios from 'axios';
import { apiBaseUrl } from '../config/constants';
import { DataTypes } from '../utils/types';

export const getInitialData = () => {
  return axios.get<DataTypes>(apiBaseUrl + '/data-structure');
};
